(() => {
  if (window.noyocoTrackCart) return;
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const decoded = value => new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent || '';
  const normalize = (item, labels) => {
    const normalized = { ...item };
    const document = new DOMParser().parseFromString(item.proof_html || '', 'text/html');
    for (const row of document.querySelectorAll('.noyoco-cart-proof__row')) {
      const label = clean(row.querySelector('dt')?.textContent);
      const value = clean(row.querySelector('dd')?.textContent);
      for (const [key, text] of Object.entries(labels || {})) {
        if (label === clean(text) && value) normalized[key] = value;
      }
    }
    delete normalized.proof_html;
    normalized.price_display = decoded(item.price_display);
    normalized.line_price_display = decoded(item.line_price_display);
    return normalized;
  };
  let chain = Promise.resolve();
  window.noyocoTrackCart = (item, cart) => {
    const snapshot = cart?.items?.map(line => ({ ...line })) || [{ ...item }];
    const task = async () => {
      const money = new Intl.NumberFormat(window.Shopify?.locale || 'fr', {
        style: 'currency', currency: cart?.currency || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      let items = snapshot.map(line => ({
        ...line,
        url: new URL(line.url, location.origin).href,
        price_display: Number.isFinite(line.final_price) ? money.format(line.final_price / 100) : decoded(line.price_display),
        line_price_display: Number.isFinite(line.final_line_price) ? money.format(line.final_line_price / 100) : decoded(line.line_price_display)
      }));
      let version = 0;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart?view=noyoco-crm&crm_version=1`, {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) throw new Error('cart-facts');
        const saved = await response.json();
        const sameCart = saved.items?.length === snapshot.length && snapshot.every(line =>
          saved.items.some(savedLine => savedLine.key === line.key && savedLine.quantity === line.quantity)
        );
        if (saved.schema_version !== 1 || !sameCart) throw new Error('cart-snapshot-changed');
        items = saved.items.map(line => normalize(line, saved.labels));
        version = 1;
      } catch (_) {
      } finally {
        clearTimeout(timer);
      }
      const lines = items.filter(line => /^\d+$/.test(String(line.variant_id)) && Number.isInteger(line.quantity) && line.quantity > 0);
      if (!lines.length) return;
      const root = window.Shopify?.routes?.root || '/';
      const restore = `${location.origin}${root}cart/${lines.map(line => `${line.variant_id}:${line.quantity}`).join(',')}?storefront=true`;
      const event = { ...item, cart_items: lines, cart_url: restore, cart_schema_version: version, cart_currency: cart?.currency || 'EUR' };
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', event]);
    };
    chain = chain.then(task, task).catch(() => {});
  };
})();
